// extracted by mini-css-extract-plugin
export default {"img":"BannerBlock_img__8IwGr"};